let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("avghK")).then(() => parcelRequire('aIqdH'));